/* eslint-disable */
// Votra Business 2.0 — undersider. Én definition pr. side, renderes af pages/business/BusinessSubPage.jsx.
// Faste regler for al copy her:
//  · Vi skriver hvad vi UDFØRER. Vi lover ikke omsætning, besparelser i procent eller kontrakter.
//  · Forsikring er det eneste, der ligger hos en partner. Revision ligger hos revisor.
//  · Kommende funktioner skrives altid som "under udvikling".

import { BILLEDER } from "./billeder";

const VOGNMAEND_PARENT = { name: "Vognmænd", path: "/business/vognmaend" };

/* Krydslinks. Ét katalog, så «Relateret»-blokken altid peger på en side, der findes.
   Links renderes som rigtige <a href>, så crawlere kan følge dem. */
const REL = {
  vognmaend: { title: "Drifts- og økonomiafdeling for vognmænd", desc: "Samlet overblik over hvad vi overtager, og hvad du beholder.", to: "/business/vognmaend" },
  drift: { title: "Drift og backoffice", desc: "Bogføring, fakturering, debitoropfølgning og løn som fast rutine.", to: "/business/drift" },
  "financial-controlling": { title: "Financial controlling", desc: "Resultat pr. bil, break-even, nøgletal og månedlig ledelsesrapport.", to: "/business/financial-controlling" },
  "fleet-management": { title: "Administrativ fleet management", desc: "Bilernes aftaler, omkostninger, dokumenter og frister pr. køretøj.", to: "/business/fleet-management" },
  compliance: { title: "Dokument- og fristovervågning", desc: "Kørekort, EU-bevis, førerkort og ADR med udløbsdatoer, holdt opdateret.", to: "/business/compliance" },
  rammeaftaler: { title: "Omkostningsgennemgang og rammeaftaler", desc: "De faste omkostninger gennemgået post for post, opgjort pr. bil.", to: "/business/rammeaftaler" },
  vaekst: { title: "Vækst og næste bil", desc: "Beslutningsgrundlag før næste bil, næste kontrakt og næste chauffør.", to: "/business/vaekst" },
  beregnere: { title: "Beregnere", desc: "Cost pr. km, break-even og næste bil, regnet på dine egne tal.", to: "/business/beregnere" },
  regnskab: { title: "Bogføring, moms og regnskab", desc: "Løbende bogføring, afstemning, momsopgørelse og årsrapporten.", to: "/business/regnskab" },
  loen: { title: "Løn og chaufførafregning", desc: "Tillæg, ventetid, overenskomstvilkår, pension og indberetninger.", to: "/business/loen" },
  virksomhedsopstart: { title: "Virksomhedsopstart", desc: "Selskab, tilladelse, åbningsbudget og administration fra dag ét.", to: "/business/virksomhedsopstart" },
  "andre-virksomheder": { title: "Andre virksomheder", desc: "Samme driftsmodel uden flåde, for små og mellemstore virksomheder.", to: "/business/andre-virksomheder" },
  portal: { title: "Votra Business Portal", desc: "Kontrakter, dokumenter, aftaler og økonomi samlet ét sted.", to: "/business/portal" },
  rekruttering: { title: "Rekruttering af chauffører", desc: "Opslag, screening, kontrol af beviser, kontrakt og onboarding.", to: "/business/rekruttering" },
  partnere: { title: "Partnernetværk med roller", desc: "Hvem gør hvad, og hvor grænsen går mellem os og en partner.", to: "/business/partnere" },
  cases: { title: "Cases", desc: "Sådan kommer en dokumenteret case til at se ud, når den er klar.", to: "/business/cases" },
  "om-os": { title: "Om Votra Business", desc: "Selskabet, koncernen og hvorfor vi findes.", to: "/business/om-os" },
  viden: { title: "Viden om økonomi og drift", desc: "Artikler om omkostninger pr. bil, likviditet, aftaler og opstart.", to: "/business/viden" },
  kontakt: { title: "Få en driftsgennemgang", desc: "En samtale om hvad du sidder med i dag, og hvad der kan flyttes.", to: "/business/kontakt" },
  vilkaar: { title: "Samarbejds- og handelsvilkår", desc: "Hvad vi leverer, og hvad vi udtrykkeligt ikke leverer.", to: "/business/vilkaar" },
  privatliv: { title: "Privatlivspolitik", desc: "Hvilke oplysninger vi behandler, hvorfor og hvor længe.", to: "/business/privatliv" },
  kurser: { title: "Vognmands- og chaufføruddannelser", desc: "Uddannelserne udbydes af Votra Danmark ApS i Votra-koncernen.", to: "/kurser" },
};

const art = (slug, title, desc) => ({ title, desc, to: `/business/viden/${slug}` });

const rel = (items, heading = "Læs videre her") => ({
  type: "related",
  heading,
  intro: "De sider og artikler, der hænger tættest sammen med denne.",
  items: items.map((it) => (typeof it === "string" ? REL[it] : it)),
});

export const BUSINESS_PAGES = {
  /* ============================================================ BEREGNERE */
  beregnere: {
    slug: "beregnere",
    parentNav: VOGNMAEND_PARENT,
    eyebrow: "Beregnere",
    h1: "Regn på din egen forretning",
    lead:
      "Tre beregnere til de spørgsmål, der afgør om en vognmandsforretning tjener penge: hvad koster en kilometer, hvor meget skal bilen køre for at løbe rundt, og kan den næste bil betale sig. Du indtaster dine egne tal, vi laver beregningen og sender den til din mail.",
    meta: {
      title: "Cost pr. km og break-even for vognmænd | Votra Business",
      description:
        "Beregn bilens omkostning pr. kilometer, break-even pr. bil og om den næste lastbil kan betale sig, inkl. likviditetsbehov. Gratis beregnere fra Votra Business.",
    },
    service: {
      name: "Beregnere til vognmænd",
      description:
        "Beregning af omkostning pr. kilometer, break-even pr. køretøj og beslutningsgrundlag for investering i næste lastbil.",
    },
    blocks: [
      { type: "calculators", heading: "Vælg beregner", intro: "Du får resultatet på skærmen og på mail, så du har det sort på hvidt, når du skal bruge det over for bank, leasingselskab eller kunde." },
      {
        type: "callout",
        title: "Hvorfor vi ikke viser et branchegennemsnit",
        text: "Fordi det ikke kan bruges til noget. To biler med samme omsætning kan give vidt forskellige resultater, afhængigt af leasingaftale, forbrug, chaufførvilkår og serviceniveau. Beregnerne arbejder derfor udelukkende med dine egne tal, vi lægger ikke skøn eller branchetal oven i.",
      },
      {
        type: "cards",
        heading: "Hvad du kan bruge resultaterne til",
        items: [
          { title: "Prissætte en ny opgave", desc: "Når du kender din omkostning pr. kilometer, kan du se om prisen holder, før du siger ja." },
          { title: "Finde den bil der trækker ned", desc: "Kør beregningen pr. bil og sammenlign. Forskellen ligger næsten altid i aftalerne, ikke i bilen." },
          { title: "Tage snakken med banken", desc: "Et regnestykke på papir er lettere at låne penge på end en mavefornemmelse." },
          { title: "Beslutte om næste bil kan bære sig selv", desc: "Inklusive de penge der skal være i kassen, før kunden har betalt den første faktura." },
        ],
      },
      {
        type: "callout",
        title: "Vil du have tallene gennemgået?",
        text: "Beregnerne giver dig et øjebliksbillede på de tal, du indtaster. En driftsgennemgang giver dig billedet på dine faktiske aftaler, bilag og kontrakter, og et konkret oplæg på, hvad vi kan overtage.",
        link: { label: "Få en driftsgennemgang", to: "/business/kontakt" },
      },
      { type: "articles", heading: "Læs mere om tallene bag" },
      rel(["financial-controlling", "vaekst", "fleet-management",
        art("resultat-pr-bil", "Resultat pr. bil", "Sådan regnes bilens eget resultat ud, post for post.")]),
    ],
    faq: [
      { q: "Koster det noget at bruge beregnerne?", a: "Nej. Du indtaster dine tal og afleverer navn og mail, så vi kan sende beregningen til dig. Der er ingen betaling og ingen forpligtelse." },
      { q: "Hvorfor skal jeg give min mail for at se resultatet?", a: "Fordi beregningen sendes til dig, så du har den på skrift, og fordi vi gerne vil kunne følge op, hvis du har brug for at få tallene gennemgået. Vi bruger ikke oplysningerne til andet og videresælger dem ikke." },
      { q: "Gemmer I mine tal?", a: "Vi gemmer de tal, du har indtastet, sammen med din henvendelse, så vi kan tale om beregningen, hvis du kontakter os. Du kan altid bede os slette dem, se privatlivspolitikken." },
      { q: "Hvor præcise er beregningerne?", a: "De er præcise på de tal, du indtaster, hverken mere eller mindre. Er leasingydelsen eller forbruget gættet, er resultatet også et gæt. Derfor er det en god idé at hente de rigtige tal frem fra dine aftaler, inden du regner." },
    ],
    cta: { title: "Skal vi regne på dine faktiske tal i stedet for de indtastede?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ VOGNMÆND */
  vognmaend: {
    slug: "vognmaend",
    eyebrow: "Vores kerneforretning",
    h1: "Drifts- og økonomiafdeling for vognmænd",
    lead:
      "Du har biler på vejen, chauffører på løn og et kontor, der aldrig bliver færdigt. Votra Business overtager kontoret: bogføring, moms, løn, fakturering, debitorer, bilernes aftaler og chaufførernes dokumenter. Du passer vejen.",
    meta: {
      title: "Drifts- og økonomipartner for vognmænd | Votra Business",
      description:
        "Votra Business overtager backoffice for vognmænd: bogføring, moms, løn, fakturering, debitorstyring og chaufførernes dokumenter. Fast rådgiver og egen portal.",
    },
    service: {
      name: "Ekstern drifts- og økonomiafdeling for vognmænd",
      description:
        "Udført backoffice, financial controlling, administrativ fleet management og dokumentovervågning for vognmænd og transportvirksomheder i Danmark.",
    },
    blocks: [
      {
        type: "split",
        heading: "Hvad vi overtager, og hvad du beholder",
        intro:
          "Det meste af en vognmandsforretning er administration, der skal gøres til tiden. Her er den konkrete fordeling, når vi arbejder sammen.",
        columns: [
          {
            title: "Det overtager vi",
            items: [
              "Løbende bogføring, afstemning og momsopgørelse",
              "Fakturering, rykkerflow og opfølgning på debitorer",
              "Løn, tillæg og chaufførafregning",
              "Kontrol og klargøring af leverandørfakturaer",
              "Bilernes aftaler: leasing, forsikring, brændstof, service, dæk",
              "Chaufførdokumenter og udløbsdatoer",
              "Kontakten til leverandører i det daglige",
              "Nøgletal, kvartalsgennemgang og ledelsesrapport",
            ],
          },
          {
            title: "Det beholder du",
            items: [
              "Kørslen, kunderne og prissætningen",
              "Beslutningen om næste bil og næste kontrakt",
              "Ansættelse og afskedigelse af chauffører",
              "Underskriften på dine egne aftaler",
              "Adgang til alt materiale i din portal, det er dine data",
            ],
          },
        ],
      },
      {
        type: "cards",
        heading: "Hvem vi typisk arbejder med",
        items: [
          { title: "Den nye vognmand", desc: "Første eller anden bil. Har brug for at administrationen er sat rigtigt op, før den vokser sig til et problem." },
          { title: "3-10 biler", desc: "Det punkt hvor ejeren ikke længere kan køre og holde styr på kontoret samtidig. Her gør vi mest forskel." },
          { title: "10+ biler", desc: "Har måske en bogholder, men mangler controlling: hvad tjener hver bil, hver chauffør og hver kontrakt." },
          { title: "Kurér og varebil", desc: "Mange små fakturaer, mange chauffører, stram likviditet. Fakturering og debitorstyring er afgørende." },
        ],
      },
      { type: "areas", heading: "Syv områder, i den rækkefølge en vognmand møder dem" },
      { type: "onboarding", heading: "Sådan kommer vi i gang", intro: "Otte trin fra første samtale til månedlig drift. De første trin tager vi os af; du skal mest svare på spørgsmål." },
      {
        type: "checklist",
        heading: "Nøgletal vi holder øje med for dig",
        intro:
          "Tallene er dine, vi opstiller dem, så de kan bruges til at træffe beslutninger. Den automatiske visning i portalen er under udvikling.",
        items: [
          "Omsætning pr. bil og pr. kontrakt",
          "Lønandel af omsætningen",
          "Brændstofandel af omsætningen",
          "Faste omkostninger pr. bil pr. måned",
          "Dækningsbidrag pr. bil",
          "Debitordage, hvor længe dine penge står ude",
          "Likviditet de næste 30-90 dage",
          "Break-even: hvad bilen skal køre hjem for at løbe rundt",
        ],
      },
      {
        type: "media",
        overline: "Overblik",
        image: BILLEDER.overblik,
        alt: "Lag af mørke glasflader med tynde gyldne kurver og søjler",
        heading: "Du skal kunne se det selv, ikke bede om det",
        text:
          "Bogholderen sender et regneark, når du spørger. Softwarefirmaet giver dig et system, men ingen til at udføre arbejdet. Du får begge dele: en fast rådgiver, der laver arbejdet, og en portal, hvor økonomien, medarbejderne, aftalerne og dokumenterne ligger samlet.",
        link: { label: "Se hele portalen", to: "/business/portal" },
      },
      { type: "portal", heading: "Sådan ser du det i portalen" },
      {
        type: "callout",
        title: "Regn selv på tallene først",
        text: "Vil du se, hvad en af dine biler koster pr. kilometer, hvor meget den skal køre for at løbe rundt, eller om den næste bil kan betale sig? Vi har lavet tre beregnere, du kan bruge gratis, du indtaster dine egne tal, og vi sender beregningen til din mail.",
        link: { label: "Åbn beregnerne", to: "/business/beregnere" },
      },
      { type: "packages", heading: "Tre niveauer", intro: "Du vælger hvor meget du afleverer. Prisen sættes efter en driftsgennemgang, bilagsmængde, antal biler og antal medarbejdere." },
      { type: "boundaries", heading: "Det gør vi ikke" },
      rel(["drift", "financial-controlling", "fleet-management", "compliance", "rammeaftaler", "vaekst"],
        "De seks områder, hver for sig"),
    ],
    faq: [
      { q: "Skal jeg skifte revisor for at bruge Votra Business?", a: "Nej. Vi overtager den løbende drift og leverer et færdigt grundlag til din revisor. Mange kunder beholder den revisor, de har." },
      { q: "Kan jeg få hjælp til kun én del, fx løn?", a: "Ja. Du kan starte med et område og lægge mere over, når det fungerer. De fleste begynder med bogføring og moms." },
      { q: "Hvilket regnskabssystem arbejder I i?", a: "Vi arbejder i dit system, hvis du har et, og opretter ellers et. Vi arbejder bl.a. i e-conomic." },
      { q: "Hvor lang tid tager det at komme i gang?", a: "Driftsgennemgangen kan ligge inden for en uge. Hvor hurtigt vi er i fuld drift, afhænger af, hvor meget der skal ryddes op i bagud, det siger vi ærligt efter gennemgangen." },
      { q: "Arbejder I med vognmænd i hele landet?", a: "Ja. Arbejdet er digitalt, og vi har kontor i Søborg og registreret adresse i Ringsted. Vi arbejder for kunder i hele Danmark." },
    ],
    cta: { title: "Få en driftsgennemgang af din vognmandsforretning", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ DRIFT */
  drift: {
    slug: "drift",
    parentNav: VOGNMAEND_PARENT,
    eyebrow: "Drift · backoffice",
    h1: "Vi overtager dit kontor",
    lead:
      "Backoffice er ikke rådgivning. Det er opgaver, der skal gøres hver uge, hele året. Her er præcis hvad der flytter ind hos os, og hvornår det sker.",
    meta: {
      title: "Outsourcet backoffice for vognmænd | Votra Business",
      description:
        "Vi overtager bogføring, moms, fakturering, debitoropfølgning, løn og leverandøradministration for vognmænd. Faste rutiner og fuldt overblik i portalen.",
    },
    service: {
      name: "Outsourcet backoffice og driftsadministration",
      description: "Løbende bogføring, moms, fakturering, debitorstyring, løn og leverandøradministration udført af Votra Business.",
    },
    blocks: [
      {
        type: "answer",
        heading: "Hvad er outsourcet backoffice for en vognmand?",
        paragraphs: [
          "Outsourcet backoffice betyder, at de administrative opgaver, der skal gøres hver uge hele året, flytter ud af dit kontor og ind hos os. Votra Business laver løbende bogføring og momsopgørelse, fakturering efter dine aftaler og kørsler, rykkere og opfølgning på debitorer, løn og chaufførafregning samt modtagelse og kontrol af leverandørfakturaer.",
          "Det er ikke rådgivning, det er udført arbejde. Du beholder kørslen, kunderne og prissætningen, og du kan se i din portal, at arbejdet bliver gjort.",
        ],
        facts: [
          "Penge ind: fakturering, rykkere og debitoropfølgning",
          "Penge ud: kontrol af leverandørfakturaer og klargøring af betalinger",
          "Lønnen: løn, tillæg, chaufførafregning og indberetninger",
          "Bogen: bogføring, moms, afstemning og grundlag til årsrapport",
        ],
      },
      {
        type: "split",
        heading: "Hvad overtager vi konkret?",
        intro: "De fire rutiner, der holder forretningen i gang, uge efter uge.",
        columns: [
          { title: "Penge ind", items: ["Fakturering efter dine aftaler og kørsler", "Rykkere efter fast kadence", "Opfølgning på debitorer, vi ringer og rykker", "Overblik over hvor pengene står ude"] },
          { title: "Penge ud", items: ["Modtagelse og kontrol af leverandørfakturaer", "Tjek af faktura mod aftale og beløb", "Klargøring af betalinger", "Afstemning af bank og kort"] },
          { title: "Lønnen", items: ["Løn, tillæg og udbetaling til tiden", "Chaufførafregning efter aftale og overenskomstvilkår", "Feriepenge, pension og indberetninger", "Ansættelseskontrakter i portalen"] },
          { title: "Bogen", items: ["Løbende bogføring og kontering", "Momsopgørelse og indberetning", "Afstemninger og oprydning i åbne poster", "Grundlag klar til årsrapport"] },
        ],
      },
      {
        type: "steps",
        heading: "Hvordan fungerer det i praksis?",
        intro: "Driftsåret hos os. Du behøver ikke huske nogen af disse datoer.",
        items: [
          { n: "Ugen", title: "Løbende", desc: "Bilag ind, fakturaer ud, debitoropfølgning, leverandørkontrol og spørgsmål besvaret." },
          { n: "Md.", title: "Hver måned", desc: "Løn, bogføring lukket, afstemning, status på likviditet og frister der nærmer sig." },
          { n: "Kvt.", title: "Hvert kvartal", desc: "Moms indberettet og kvartalsgennemgang: resultat, omkostninger, debitorer og hvad der skal handles på." },
          { n: "År", title: "Hvert år", desc: "Grundlag til årsrapport gjort klar og afleveret til revisor, plus budget for det kommende år." },
        ],
      },
      {
        type: "callout",
        title: "Hvorfor det betyder noget i transport",
        text: "I transport er pengene bundet i biler, og indtægten kommer ind efter kørslen er udført. Faktureres der en uge for sent, og rykkes der ikke, er det dig der finansierer kunden. Det er den enkeltbrik, der oftest koster likviditet hos en vognmand, og det er ren rutine at rette.",
      },
      {
        type: "media",
        image: BILLEDER.motorvej,
        alt: "Mørk motorvej med lysspor fra biler i aftenmørket",
        caption:
          "Indtægten kommer ind efter kørslen er udført. Derfor er det fakturadatoen og rykkerkadencen, der afgør, om det er dig eller kunden, der finansierer turen.",
      },
      { type: "portal", heading: "Sådan ser du det i portalen" },
      { type: "packages" },
      rel(["regnskab", "loen", "financial-controlling", "compliance",
        art("fakturering-og-rykkere", "Fakturering og rykkere", "Hvorfor sen fakturering koster likviditet, og hvad der kan gøres.")]),
    ],
    faq: [
      { q: "Hvordan afleverer jeg bilag?", a: "Du sender dem, som det passer dig: foto, mail eller direkte fra leverandøren til os. Vi sætter flowet op, så du ikke skal sortere." },
      { q: "Kontakter I mine kunder direkte?", a: "Kun hvis du vil det. Mange lader os stå for rykkere og opfølgning, fordi det er lettere at holde en stram linje, når det ikke er ejeren selv der ringer." },
      { q: "Hvad hvis der er rod i de sidste måneder?", a: "Så rydder vi op først. Vi siger ærligt, hvor meget arbejde det er, før vi går i gang, ingen overraskelser bagefter." },
    ],
    cta: { title: "Skal vi tage kontoret?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ CONTROLLING */
  "financial-controlling": {
    slug: "financial-controlling",
    parentNav: VOGNMAEND_PARENT,
    eyebrow: "Controlling",
    h1: "Financial controlling for vognmænd",
    lead:
      "Et regnskab fortæller dig, hvad der er sket. Controlling fortæller dig, hvad du skal gøre. Vi sætter dine tal op, så du kan se hvilke biler, chauffører og kontrakter der faktisk tjener penge.",
    meta: {
      title: "Financial controlling for vognmænd | Votra Business",
      description:
        "Hvad er financial controlling, og hvordan beregner man resultat pr. bil? Votra Business opstiller omkostninger, dækningsbidrag og break-even pr. bil.",
    },
    service: {
      name: "Financial controlling for transportvirksomheder",
      description: "Opstilling af omkostningsstruktur, dækningsbidrag, resultat pr. bil og månedlig ledelsesrapport for vognmænd.",
    },
    blocks: [
      {
        type: "answer",
        heading: "Hvad er financial controlling?",
        paragraphs: [
          "Financial controlling er at bruge regnskabstallene fremadrettet: følge omkostningerne, opdele resultatet pr. bil, chauffør og kontrakt, beregne break-even og lave beslutningsgrundlag. Hvor bogholderiet registrerer, hvad der er sket, bruger controlling tallene til at styre.",
          "Hos Votra Business er controlling udført arbejde. Vi opstiller omkostningsstrukturen, henfører omkostningerne til den rigtige bil hver måned, leverer en månedlig ledelsesrapport og går tallene igennem med dig hvert kvartal. Votra Business er ikke revisionsvirksomhed; skal regnskabet revideres eller forsynes med en revisorerklæring, løses den del af en revisor.",
        ],
        facts: [
          "Resultat og dækningsbidrag pr. bil",
          "Break-even pr. bil pr. måned",
          "Månedlig ledelsesrapport og kvartalsgennemgang",
          "Beslutningsgrundlag før ny bil, chauffør eller kontrakt",
        ],
      },
      {
        type: "table",
        heading: "Hvad er forskellen på en bogholder, en revisor og en controller?",
        intro: "De fire roller bliver ofte blandet sammen. Her er forskellen, så du ved hvad du køber.",
        columns: ["", "Ser på", "Tidsperspektiv", "Spørgsmålet der besvares"],
        rows: [
          ["Bogholder", "Bilag og posteringer", "Bagud", "Er det bogført rigtigt?"],
          ["Revisor", "Årsregnskabet", "Bagud, én gang om året", "Kan regnskabet erklæres?"],
          ["Financial controller", "Drift og nøgletal", "Fremad", "Hvor tjener og taber vi penge?"],
          ["Votra Business", "Bogholderi + controlling + bilernes økonomi", "Løbende", "Hvad skal du gøre ved det, og hvem gør det?"],
        ],
        note: "Votra Business er ikke revisionsvirksomhed. Vi laver bogføring, controlling og årsrapporten; skal regnskabet revideres eller forsynes med en revisorerklæring, løses den del af en revisor.",
      },
      {
        type: "checklist",
        heading: "Hvordan beregner man resultat pr. bil?",
        intro:
          "Princippet er enkelt: bilens egen indtægt minus bilens egne omkostninger minus dens andel af de faste. Det svære er at få omkostningerne hen på den rigtige bil hver måned, det er arbejdet.",
        items: [
          "Indtægt: kørsel, tillæg og ventetid faktureret på bilen",
          "Chauffør: løn, tillæg, pension og feriepenge",
          "Brændstof: forbrug fra tankkort henført til bilen",
          "Kapital: leasingydelse eller afskrivning og rente",
          "Drift: forsikring, vægtafgift, service, dæk, reparationer, syn",
          "Vej: vejafgifter, broer, færger, parkering",
          "Fælles: andel af administration, værksted og ledelse",
          "Resultat: dækningsbidrag pr. bil og break-even pr. måned",
        ],
        note: "Vi leverer opstillingen som del af controlling. Den automatiske visning pr. bil i portalen er under udvikling.",
      },
      {
        type: "cards",
        heading: "Hvad hjælper vi med?",
        items: [
          { title: "Kvartalsgennemgang", desc: "Vi sidder sammen og går tallene igennem: resultat, omkostninger, debitorer, likviditet og hvad der skal handles på." },
          { title: "Månedlig ledelsesrapport", desc: "Et fast, kort dokument: hvad kom ind, hvad gik ud, hvad ændrede sig, hvad kræver en beslutning." },
          { title: "Baseline og udvikling", desc: "Vi fastlægger dine nøgletal ved start, så de næste måneder kan måles mod noget." },
          { title: "Beslutningsgrundlag", desc: "Før en ny bil, en ny chauffør eller en ny kontrakt regner vi den igennem, før du skriver under." },
          { title: "Omkostningsgennemgang", desc: "Dine faste omkostninger gennemgået post for post, så du kan se hvor der er noget at hente." },
          { title: "Likviditetsoverblik", desc: "Hvad der står ude, hvad der skal betales, og hvad der er tilbage om 30-90 dage.", badge: "soon" },
        ],
      },
      {
        type: "file",
        overline: "Eksempel",
        heading: "Se den månedlige ledelsesrapport, før du beslutter dig",
        text: "Her er et anonymiseret eksempel på det dokument, du får hver måned: hovedtal, resultat pr. bil, nøgletal, debitoroversigt, de frister der nærmer sig, og de handlingspunkter vi tager med til gennemgangen.",
        note: "Virksomheden er anonymiseret, og alle tal i eksemplet er opdigtede og runde. Rapporten er ikke et årsregnskab og indeholder ingen revisorerklæring.",
        button: "Hent eksemplet (PDF)",
        file: "/business/example-management-report",
      },
      {
        type: "callout",
        title: "Et eksempel på hvorfor det betyder noget",
        text: "To biler kan køre samme omsætning og alligevel give vidt forskellige resultater: forskellig leasingydelse, forskelligt forbrug, forskellige tillæg til chaufføren, forskelligt serviceniveau. Uden opdeling pr. bil ser man kun summen, og så kan en bil, der taber penge hver måned, blive dækket af de andre i årevis.",
        link: { label: "Regn selv break-even pr. bil", to: "/business/beregnere" },
      },
      { type: "packages", intro: "Controlling er med fra Business+ og op." },
      rel(["drift", "beregnere", "fleet-management",
        art("resultat-pr-bil", "Resultat pr. bil", "Sådan regnes bilens eget resultat ud, post for post."),
        art("bogholder-revisor-eller-controller", "Bogholder, revisor eller controller", "Hvem gør hvad, og hvornår har du brug for hvem.")]),
    ],
    faq: [
      { q: "Hvad er financial controlling helt konkret?", a: "Konkret er det fire ting: omkostningerne henføres til den rigtige bil hver måned, resultatet opdeles pr. bil, chauffør og kontrakt, break-even beregnes, og du får en månedlig ledelsesrapport plus en kvartalsgennemgang, hvor vi aftaler hvad der skal handles på." },
      { q: "Hvordan beregner jeg break-even pr. bil?", a: "Læg bilens faste omkostninger pr. måned sammen, leasing eller afskrivning, forsikring, vægtafgift, serviceaftale og andel af administration, og del med dækningsbidraget pr. kørt enhed, fx pr. km eller pr. tur. Resultatet er, hvad bilen mindst skal køre hjem for at løbe rundt. Vi opstiller det på dine egne tal." },
      { q: "Hvor stor bør brændstofandelen være?", a: "Det varierer med kørselstype, bil og dieselpris, så et branchetal er ikke et styringsmål. Det brugbare er din egen udvikling: hvordan andelen bevæger sig måned for måned, og hvordan dine biler ligger i forhold til hinanden." },
      { q: "Kan jeg se et eksempel på ledelsesrapporten?", a: "Ja. Der ligger et anonymiseret eksempel til download på denne side. Virksomheden er anonymiseret, og tallene i eksemplet er opdigtede og runde, så du kan se formatet og indholdet uden at se en kundes tal." },
      { q: "Kan I lave controlling uden at overtage bogføringen?", a: "Vi kan, men kvaliteten afhænger af, hvor godt det underliggende bogholderi er ført. Vi siger ærligt fra, hvis grundlaget ikke er til at styre efter." },
    ],
    cta: { title: "Vil du se, hvad hver bil tjener?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ FLEET */
  "fleet-management": {
    slug: "fleet-management",
    parentNav: VOGNMAEND_PARENT,
    eyebrow: "Fleet",
    h1: "Fleet management er mere end GPS",
    lead:
      "Telematik viser hvor bilen er, og hvordan den bliver kørt. Det siger ikke, hvad bilen koster, hvornår leasingaftalen udløber, eller om forsikringsfakturaen stemmer med aftalen. Det er den del, vi laver.",
    meta: {
      title: "Administrativ fleet management for vognmænd | Votra Business",
      description:
        "Vi administrerer din vognpark: leasing, forsikring, brændstof, service, dæk, frister og fakturakontrol pr. bil. Ikke GPS, men bilens økonomi og papirer.",
    },
    service: {
      name: "Administrativ fleet management",
      description: "Administration af vognparkens aftaler, omkostninger, dokumenter og frister pr. køretøj, samlet med regnskabet.",
    },
    blocks: [
      {
        type: "answer",
        heading: "Hvad er administrativ fleet management?",
        paragraphs: [
          "Administrativ fleet management er styringen af vognparkens aftaler, omkostninger, dokumenter og frister pr. bil, koblet til regnskabet. Votra Business holder leasing eller finansiering, forsikring, brændstof og tankkort, service- og dækaftaler samt vejafgift liggende med beløb, periode og udløbsdato på den enkelte bil og kontrollerer fakturaerne mod aftalen.",
          "Det er ikke telematik. Telematik viser, hvor bilen er, og hvordan den bliver kørt. Vi arbejder med, hvad bilen koster, og hvornår papirerne skal fornyes. Vi er ikke telematikleverandør, og vi sælger ikke GPS.",
        ],
        facts: [
          "Aftaler pr. bil: leasing, forsikring, brændstof, service, dæk, vejafgift",
          "Faste og variable omkostninger henført til den enkelte bil",
          "Kontrol af faktura mod aftale, beløb og periode",
          "Frister: syn, leasingudløb, forsikringsfornyelse og tachograf-kontrol",
        ],
      },
      {
        type: "table",
        heading: "Hvad er forskellen på telematik, flådeadministration og os?",
        intro: "Markedet bruger samme ord om tre forskellige ting. Her er hvem der gør hvad.",
        columns: ["", "Leverer", "Mangler"],
        rows: [
          ["Telematik (GPS, kørebog)", "Position, køreadfærd, forbrug, tachografdata", "Økonomien. Systemet ved ikke hvad bilen tjener"],
          ["Flådeadministratorer", "Administration af leasede firmabiler og personbilsflåder", "Vognmandens kørselsøkonomi, chaufførøkonomi og dækningsbidrag pr. bil"],
          ["Votra Business", "Bilens aftaler, omkostninger, dokumenter og frister, koblet til regnskabet", "Vi er ikke telematikleverandør. Vi sælger ikke GPS"],
        ],
      },
      {
        type: "split",
        heading: "Hvad holder vi styr på pr. bil?",
        columns: [
          { title: "Aftaler", items: ["Leasing eller finansiering: ydelse, periode, restværdi", "Forsikring: dækning, præmie, selvrisiko, fornyelse", "Brændstof og tankkort", "Service- og dækaftaler", "Vejafgift og bizz"] },
          { title: "Omkostninger", items: ["Fast omkostning pr. bil pr. måned", "Variable omkostninger henført til bilen", "Kontrol af faktura mod aftale", "Skader og reparationer", "Udvikling måned for måned"] },
          { title: "Frister og papirer", items: ["Syn og periodisk kontrol", "Leasingudløb og aflevering", "Forsikringsfornyelse", "Tachograf-kontrol", "Dokumenter samlet pr. bil"] },
        ],
      },
      {
        type: "cards",
        heading: "Under udvikling",
        intro: "Vi viser det ikke som eksisterende, før det kører. Disse funktioner er på vej i portalen:",
        items: [
          { title: "Cost pr. km pr. bil", desc: "Beregnet automatisk ud fra kørte kilometer og bilens omkostninger.", badge: "soon" },
          { title: "Utilization", desc: "Hvor meget af kapaciteten der faktisk bliver brugt.", badge: "soon" },
          { title: "Automatiske fristvarsler", desc: "Varsling før syn, leasingudløb, forsikringsfornyelse og dokumentudløb.", badge: "soon" },
          { title: "Fleet-dashboard", desc: "Alle biler side om side med dækningsbidrag og omkostninger.", badge: "soon" },
        ],
      },
      {
        type: "callout",
        title: "Fakturakontrol er den kedelige del, der tjener sig hjem",
        text: "Leasingydelser, forsikringspræmier, serviceaftaler og tankkort ændrer sig løbende, og fakturaer bliver sendt uden at nogen holder dem op mod aftalen. Vi har aftalen, beløbet og perioden liggende pr. bil, så afvigelsen bliver fanget, mens den stadig kan rettes.",
        link: { label: "Beregn hvad bilen koster pr. km", to: "/business/beregnere" },
      },
      { type: "portal", heading: "Bilerne i portalen" },
      rel(["rammeaftaler", "financial-controlling", "compliance",
        art("hvad-koster-en-lastbil-om-maaneden", "Hvad koster en lastbil om måneden", "Posterne der tilsammen udgør bilens faste omkostning."),
        art("naar-leasingbilen-skal-afleveres", "Når leasingbilen skal afleveres", "Det der afgør, om afleveringen bliver en regning.")]),
    ],
    faq: [
      { q: "Skal jeg have GPS i bilerne for at bruge jer?", a: "Nej. Vi arbejder med aftaler, omkostninger, dokumenter og frister. Har du telematik, kan vi bruge de data, systemet giver, men det er ikke et krav." },
      { q: "Kan I overtage kontakten til leasingselskab og forsikring?", a: "Vi kan tage det daglige: dokumenter, fakturaer, fornyelser og praktiske spørgsmål. Forsikringsrådgivning og formidling ligger hos partneren, og aftalen er altid din." },
      { q: "Hvad koster administration pr. bil?", a: "Fleet-administration prissættes pr. bil pr. måned oven på grundprisen, fordi arbejdsmængden følger antallet af biler. Det konkrete niveau fastsættes efter en driftsgennemgang." },
    ],
    cta: { title: "Skal vi tage vognparkens papirer og økonomi?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ COMPLIANCE */
  compliance: {
    slug: "compliance",
    parentNav: VOGNMAEND_PARENT,
    eyebrow: "Compliance",
    h1: "Må han køre i morgen?",
    lead:
      "Et udløbet førerkort, et EU-bevis der skulle have været fornyet, en ADR-attest ingen holdt øje med. Det er sjældent uvilje, det er en dato, ingen havde ansvaret for. Vi tager ansvaret for datoerne.",
    meta: {
      title: "Dokumenter og frister for chauffører | Votra Business",
      description:
        "Vi samler chaufførernes kørekort, EU-bevis, førerkort og ADR med udløbsdatoer og holder øje med fristerne. Administrativ styring, ikke juridisk rådgivning.",
    },
    service: {
      name: "Administrativ dokument- og fristovervågning",
      description: "Samling og overvågning af chaufførdokumenter, certifikater og udløbsdatoer for transportvirksomheder.",
    },
    blocks: [
      {
        type: "answer",
        heading: "Hvad er dokument- og fristovervågning?",
        paragraphs: [
          "Dokument- og fristovervågning er administrativ styring af de papirer, der skal være gyldige, før en chauffør må køre, og før en bil må være på vejen. Votra Business lægger kørekort, EU-bevis, førerkort til tachograf og ADR-bevis ind pr. chauffør med nummer og udløbsdato, og tilladelser, forsikringspolicer, leasingaftaler og syn ind pr. bil. Fristerne gennemgås som en fast del af den månedlige drift, så du får besked i god tid.",
          "Vi har en certificeret sikkerhedsrådgiver ansat, så spørgsmål om transport af farligt gods kan tages internt. Vi giver ikke juridisk rådgivning, og vi erklærer ikke, at din virksomhed overholder reglerne; det ansvar ligger hos virksomheden.",
        ],
        facts: [
          "Chaufføren: kørekort, EU-bevis, førerkort og ADR med udløbsdato",
          "Virksomheden: tilladelser, forsikring, leasing og syn pr. bil",
          "Fristerne gennemgået hver måned, ikke når det er for sent",
          "Dokumenterne samlet i portalen, klar til at fremvise",
        ],
      },
      {
        type: "split",
        heading: "Hvad holder vi styr på?",
        columns: [
          { title: "Chaufføren", items: ["Kørekort: nummer og udløb", "EU-bevis (chaufføruddannelse): nummer og udløb", "Førerkort til tachograf: nummer og udløb", "ADR-bevis: nummer og udløb", "Ansættelseskontrakt og overenskomstvilkår", "Pension, arbejdstøj, brændstofkort, fast bil eller rute"] },
          { title: "Virksomheden", items: ["Tilladelser og tilhørende dokumentation", "Forsikringspolicer og fornyelsesdatoer", "Leasingaftaler og udløb", "Syn og periodisk kontrol pr. bil", "Dokumentarkiv du kan trække fra ved kontrol"] },
        ],
      },
      {
        type: "steps",
        heading: "Hvordan fungerer fristovervågningen?",
        items: [
          { n: "01", title: "Vi samler ind", desc: "Alle dokumenter på alle chauffører og biler lægges ind med nummer og udløbsdato. Hullerne bliver synlige med det samme." },
          { n: "02", title: "Vi følger op", desc: "Vi gennemgår fristerne som en fast del af den månedlige drift og siger til i god tid, før noget udløber." },
          { n: "03", title: "Du handler i tid", desc: "Fornyelse, kursus eller erstatningsdokument planlægges, før chaufføren står med et papir der ikke gælder." },
          { n: "04", title: "Det er dokumenteret", desc: "Dokumenterne ligger samlet i portalen, så du kan finde dem, når nogen spørger." },
        ],
      },
      {
        type: "callout",
        title: "Farligt gods: vi har en certificeret sikkerhedsrådgiver i huset",
        text: "ADR-området er et selvstændigt fagfelt, og de fleste eksterne bogholdere og administrationspartnere må sende det videre. Votra Business har en certificeret sikkerhedsrådgiver ansat, så spørgsmål om transport af farligt gods kan tages internt, sammen med den administrative styring af chaufførernes ADR-beviser og udløbsdatoer.",
      },
      {
        type: "callout",
        tone: "warn",
        title: "Vigtig afgrænsning",
        text: "Vi laver administrativ dokumentstyring og overvågning af frister, og vi har en certificeret sikkerhedsrådgiver til farligt gods. Vi giver ikke juridisk rådgivning, og vi erklærer ikke, at din virksomhed overholder reglerne, det ansvar ligger hos virksomheden. Juridiske spørgsmål, tvister og sager hører hos en advokat.",
      },
      {
        type: "cards",
        heading: "Under udvikling",
        items: [
          { title: "Automatiske varsler", desc: "Notifikation på tværs af alle dokumenttyper og aftaler, før de udløber.", badge: "soon" },
          { title: "Compliance-overblik", desc: "Ét billede af hvilke chauffører og biler der er klar, og hvad der mangler.", badge: "soon" },
        ],
      },
      { type: "portal", heading: "Dokumenterne i portalen" },
      rel(["loen", "rekruttering", "fleet-management",
        art("chauffoerens-dokumenter-og-frister", "Chaufførens dokumenter og frister", "Hvilke beviser skal være gyldige, og hvornår udløber de."),
        art("adr-og-lovkrav", "ADR og lovkrav", "Hvad der gælder, når der køres med farligt gods.")]),
    ],
    faq: [
      { q: "Overholder min virksomhed reglerne, hvis jeg bruger jer?", a: "Vi giver dig overblik over dine dokumenter og frister, så du kan handle i tid. Ansvaret for at overholde reglerne ligger hos dig som virksomhed, vi erklærer os ikke om det." },
      { q: "Hjælper I med køre- og hviletid?", a: "Vi arbejder med den administrative side: at dokumenterne og førerkortene er i orden og fristerne overholdt. Analyse af tachografdata og rådgivning om overtrædelser løses af en specialist på området." },
      { q: "Hvad med ADR?", a: "Vi holder styr på chaufførernes ADR-beviser og udløbsdatoer som del af dokumentovervågningen, og vi har en certificeret sikkerhedsrådgiver ansat, så spørgsmål om transport af farligt gods kan tages direkte med os." },
    ],
    cta: { title: "Skal vi samle dokumenterne og holde øje med datoerne?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ RAMMEAFTALER */
  rammeaftaler: {
    slug: "rammeaftaler",
    parentNav: VOGNMAEND_PARENT,
    eyebrow: "Omkostninger",
    h1: "Vi finder pengene i dine faste omkostninger",
    lead:
      "Vi lover dig ikke en procentsats. Vi gennemgår dine faste omkostninger post for post, henter tilbud og lægger det frem, og du beslutter. Skifter du, tager vi papirarbejdet og den løbende administration.",
    meta: {
      title: "Rammeaftaler for vognmænd | Votra Business",
      description:
        "Gennemgang af faste omkostninger pr. bil og adgang til aftaler gennem Votras partnernetværk. Du indgår aftalen, vi laver arbejdet omkring den.",
    },
    service: {
      name: "Omkostningsgennemgang og adgang til rammeaftaler",
      description: "Gennemgang af faste omkostninger pr. køretøj og adgang til leverandøraftaler gennem Votras partnernetværk.",
    },
    blocks: [
      {
        type: "answer",
        heading: "Hvad er en omkostningsgennemgang?",
        paragraphs: [
          "En omkostningsgennemgang er en gennemgang af dine faste omkostninger post for post, opgjort pr. bil, så du kan se hvad en bil koster om måneden, før den har kørt en meter. Votra Business kortlægger posterne, henter sammenlignelige tilbud på det, hvor der er noget at hente, og lægger forskellen frem i kroner.",
          "Du beslutter, og du skriver under med leverandøren; aftalen er din, ikke vores. Skifter du, tager vi papirarbejdet og holder derefter aftalen, beløbet og fristen i portalen og kontrollerer fakturaerne mod den. Vi lover ikke en procentsats, og vores partnernetværk er i dag smalt og mest stærkt på forsikring.",
        ],
        facts: [
          "Forsikring, leasing, brændstof, service, dæk og vejafgift",
          "Telefoni, it, abonnementer og bankvilkår",
          "Sammenlignelige tilbud, forskellen lagt frem i kroner",
          "Løbende kontrol af fakturaer mod den aftale, du valgte",
        ],
      },
      {
        type: "checklist",
        heading: "Hvilke poster gennemgår vi?",
        items: [
          "Forsikring: dækning, præmie og selvrisiko pr. bil",
          "Leasing og finansiering: ydelse, periode og restværdi",
          "Brændstof og tankkort",
          "Service, dæk og værksted",
          "Vejafgift, bizz og færger",
          "Telefoni, it og abonnementer",
          "Bank: gebyrer, kassekredit og rentevilkår",
          "Løn og pension: er vilkårene som aftalt",
        ],
      },
      {
        type: "steps",
        heading: "Hvordan fungerer det?",
        items: [
          { n: "01", title: "Vi kortlægger", desc: "Alle faste omkostninger samles pr. bil, så du kan se hvad en bil koster om måneden, før den har kørt en meter." },
          { n: "02", title: "Vi henter tilbud", desc: "Vi bruger vores partnernetværk og markedet og indhenter sammenlignelige tilbud på de poster, hvor der er noget at hente." },
          { n: "03", title: "Du beslutter", desc: "Vi lægger forskellen frem i kroner. Du skriver under med leverandøren, aftalen er din, ikke vores." },
          { n: "04", title: "Vi administrerer", desc: "Herefter holder vi aftalen, beløbet og fristen i portalen og kontrollerer fakturaerne mod den." },
        ],
      },
      {
        type: "callout",
        title: "Ærligt om omfanget",
        text: "Vores partnernetværk er i dag smalt og mest stærkt på forsikring gennem samarbejdet med fleetpartner.dk. Vi påstår ikke at være et indkøbsfællesskab med aftaler på tyve områder, er du medlem af en brancheorganisation med et bredere rabatprogram, så brug det. Vores værdi er, at vi laver arbejdet: gennemgangen, sammenligningen, skiftet og den løbende kontrol.",
      },
      { type: "partners", heading: "Vores partnernetværk", intro: "Hvert logo har en rolle. Vi skriver rollen, så du ved hvem der gør hvad." },
      rel(["fleet-management", "financial-controlling", "partnere",
        art("forsikring-af-lastbil-og-gods", "Forsikring af lastbil og gods", "Dækninger, selvrisiko og hvad der er værd at tjekke."),
        art("daek-service-og-uforudsete-reparationer", "Dæk, service og reparationer", "De poster der svinger mest fra måned til måned.")]),
    ],
    faq: [
      { q: "Tager I provision af aftalerne?", a: "Vi tjener vores penge på det arbejde, vi udfører for dig. Hvis en aftale indebærer en henvisning, siger vi det, og du får altid forskellen i kroner lagt frem, så du selv kan vurdere." },
      { q: "Sælger I forsikring?", a: "Nej. Forsikring er det eneste, vi lægger uden for huset. Rådgivning og formidling ligger hos partneren, og aftalen er mellem dig og selskabet. Vi håndterer administrationen og holder øje med fornyelser." },
      { q: "Hvad hvis jeg ikke vil skifte noget?", a: "Så skifter du ikke noget. Gennemgangen er stadig værd at have, fordi du får at vide, hvad en bil koster dig om måneden." },
    ],
    cta: { title: "Skal vi gennemgå dine faste omkostninger?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ VÆKST */
  vaekst: {
    slug: "vaekst",
    parentNav: VOGNMAEND_PARENT,
    eyebrow: "Vækst",
    h1: "Kan næste bil betale sig?",
    lead:
      "Vækst i transport er sjældent et salgsproblem. Det er et spørgsmål om, hvorvidt den næste bil, den næste chauffør og den næste kontrakt kan bære sig selv, og om administrationen kan følge med.",
    meta: {
      title: "Vækst for vognmænd: næste bil og kontrakt | Votra Business",
      description:
        "Beslutningsgrundlag før næste bil og næste kontrakt: budget, break-even, likviditet og bemanding. Plus rekruttering og uddannelse gennem Votra-koncernen.",
    },
    service: {
      name: "Beslutningsgrundlag og vækstplanlægning for vognmænd",
      description: "Budget, break-even og likviditetsvurdering før investering i nye køretøjer, kontrakter og medarbejdere.",
    },
    blocks: [
      {
        type: "answer",
        heading: "Hvornår kan næste bil betale sig?",
        paragraphs: [
          "Næste bil kan betale sig, når den kørsel du har i hånden dækker bilens faste omkostninger og chaufførens løn med en margin, der kan holde til tomgang, og når likviditeten kan bære de første måneder, før kunden har betalt den første faktura. Votra Business stiller regnestykket op på dine egne tal og aftaler, før du skriver under.",
          "Vi sælger ikke kørselsopgaver og garanterer ikke kontrakter. Vi laver beslutningsgrundlaget: budget for bilen, break-even, likviditetsbehov og bemanding, og vi hjælper med rekruttering og med at bygge en administration, der kan holde til flere biler.",
        ],
        facts: [
          "Bilens faste omkostning pr. måned",
          "Chaufførens samlede omkostning inkl. tillæg, pension og feriepenge",
          "Break-even: hvad bilen mindst skal køre hjem",
          "Likviditetsbehov de første 90 dage",
        ],
      },
      {
        type: "checklist",
        heading: "Hvad regner vi igennem, før du skriver under?",
        intro: "Vi stiller det samme op hver gang, så beslutningen bliver truffet på tal og ikke på mavefornemmelse. Du kan selv lave den første version i vores beregner «Hvad koster næste bil».",
        items: [
          "Hvad koster bilen fast pr. måned, leasing, forsikring, afgift, service",
          "Hvad koster chaufføren inkl. tillæg, pension og feriepenge",
          "Hvad skal bilen køre hjem for at nå break-even",
          "Hvad gør den ved likviditeten de første 90 dage",
          "Hvad sker der, hvis kontrakten falder væk efter 6 måneder",
          "Hvad gør den ved din samlede omkostningsstruktur",
        ],
        note: "Beregneren giver dig et øjebliksbillede på de tal, du indtaster. Driftsgennemgangen giver dig billedet på dine faktiske aftaler.",
      },
      {
        type: "callout",
        title: "Prøv beregneren først",
        text: "«Hvad koster næste bil» viser bilens månedlige omkostning, hvad den giver i resultat ved den omsætning du forventer, og hvor mange penge der skal være i kassen, før kunden har betalt den første faktura.",
        link: { label: "Åbn beregneren", to: "/business/beregnere" },
      },
      {
        type: "cards",
        heading: "Hvad hjælper vi med?",
        items: [
          { title: "Budget for næste bil", desc: "Fuldt regnestykke på den konkrete bil og den konkrete kørsel, før du binder dig." },
          { title: "Vurdering af ny kontrakt", desc: "Holder prisen, når chaufførløn, tomkørsel, ventetid og brændstoftillæg er regnet med?" },
          { title: "Rekruttering", desc: "Vi hjælper med at finde, ansætte og få chauffører på plads med kontrakt og papirer i orden.", to: "/business/rekruttering" },
          { title: "Uddannelse", desc: "Vognmands- og chaufføruddannelser løses i Votra-koncernen hos Votra Danmark, der har uddannet vognmænd siden 2015." },
          { title: "Opbygning af backoffice", desc: "Administrationen skal kunne holde til 10 biler, før du har 10 biler. Vi bygger den med." },
          { title: "Finansiering", desc: "Vi hjælper dig gennem processen med finansierings- og leasingpartnere. Kreditvurderingen ligger hos leverandøren." },
        ],
      },
      { type: "packages", intro: "Vækst kræver, at de to første niveauer kører. Vi starter altid med driften." },
      rel(["beregnere", "financial-controlling", "rekruttering", "virksomhedsopstart",
        art("sund-indtjening", "Sund indtjening i transport", "Hvad der skal være tilbage, når bilen har kørt.")]),
    ],
    faq: [
      { q: "Hvad kigger I på, når I vurderer om en ny bil kan bære sig selv?", a: "Når den kørsel, du har i hånden, dækker bilens faste omkostninger og chaufførens løn med en margin, der kan holde til tomgang, og når likviditeten kan bære de første måneder. Vi regner det igennem på dine egne tal og aftaler." },
      { q: "Hjælper I med at finde kørsel?", a: "Nej. Vi sælger ikke kørselsopgaver og garanterer ikke kontrakter. Vi gør dig i stand til at regne på dem, du får tilbudt, og til at fremstå professionelt, når en kunde beder om dokumentation." },
      { q: "Kan I hjælpe, hvis jeg vil sælge eller overdrage virksomheden?", a: "Vi kan sørge for, at tallene og papirerne er i orden og kan fremlægges. Selve handlen, værdiansættelsen og det juridiske løses af revisor, advokat og eventuelt en mægler." },
    ],
    cta: { title: "Skal vi regne på næste bil?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ OPSTART */
  virksomhedsopstart: {
    slug: "virksomhedsopstart",
    eyebrow: "Start",
    h1: "Fra idé til kørende virksomhed",
    lead:
      "Skal du være vognmand, er der tre ting der skal på plads: selskabet, tilladelsen og administrationen. Vi laver alle tre, og sætter driften op, så den kan holde, når bilen begynder at køre.",
    meta: {
      title: "Bliv vognmand: selskab og tilladelse | Votra Business",
      description:
        "Vi stifter selskabet, laver åbningsbudgettet, søger gods- eller varebilstilladelse og sætter bogføring, fakturering og dokumentflow op fra dag ét.",
    },
    service: {
      name: "Virksomhedsopstart for vognmænd",
      description: "Stiftelse af selskab, åbningsbudget, ansøgning om tilladelse og opsætning af administration for nye vognmænd.",
    },
    blocks: [
      {
        type: "steps",
        heading: "Rækkefølgen",
        items: [
          { n: "01", title: "Afklaring", desc: "Hvilken kørsel, hvilken bil, hvilken tilladelse, og hvad kræver det af kapital og dokumentation." },
          { n: "02", title: "Selskab", desc: "Stiftelse af ApS, kapital, vedtægter, ejerregistrering og CVR. Vi sørger for, at det hele er registreret korrekt." },
          { n: "03", title: "Åbningsbudget", desc: "Hvad koster det at komme i gang, hvad koster det at køre, og hvornår løber det rundt. Før du leaser noget." },
          { n: "04", title: "Tilladelse", desc: "Ansøgning om gods- eller varebilstilladelse med den dokumentation, myndigheden kræver." },
          { n: "05", title: "Bil og aftaler", desc: "Leasing, forsikring, brændstofkort og serviceaftale, aftalerne er dine, papirarbejdet er vores." },
          { n: "06", title: "Administration", desc: "Regnskab, fakturering, dokumentflow og portal sat op fra første faktura, så du ikke skal rydde op bagefter." },
        ],
      },
      {
        type: "callout",
        title: "Uddannelsen ligger i koncernen",
        text: "Vognmandsuddannelsen og vognmandsprøven udbydes af Votra Danmark ApS, der har uddannet vognmænd og chauffører siden 2015. Skal du først have beviset, starter du der, og Votra Business står klar, når selskabet skal stiftes.",
        link: { label: "Se vognmandsuddannelserne", to: "/kurser" },
      },
      {
        type: "split",
        heading: "Det du skal regne med",
        columns: [
          { title: "Før første tur", items: ["Selskabskapital og stiftelsesomkostninger", "Dokumentation til tilladelsen", "Depositum og første leasingydelse", "Forsikring og afgift", "Arbejdstøj, kort og udstyr"] },
          { title: "De første 90 dage", items: ["Lønudbetaling før kunderne har betalt", "Brændstof løbende", "Faste omkostninger uanset kørsel", "Betalingsfrister hos dine kunder", "En buffer til det uforudsete"] },
        ],
      },
      rel(["regnskab", "drift", "vaekst", "kurser",
        art("vognmandstilladelse-krav", "Krav til vognmandstilladelse", "Hvad myndigheden kræver, og hvad der skal dokumenteres."),
        art("aabningsbudget-foerste-bil", "Åbningsbudget til første bil", "Hvad der skal være i kassen, før bilen ruller.")]),
    ],
    faq: [
      { q: "Hvad kræver det at blive vognmand?", a: "Du skal have den rette tilladelse til den kørsel, du vil udføre, et selskab der kan bære den, og dokumentation for økonomi og faglige krav. Kravene fastsættes af myndigheden, vi hjælper med ansøgningen og det, der skal vedlægges." },
      { q: "Kan I søge tilladelsen for mig?", a: "Vi forbereder og indsender ansøgningen med den dokumentation, der skal med. Afgørelsen træffes af myndigheden." },
      { q: "Hvor hurtigt kan jeg være i gang?", a: "Selskabet kan stiftes hurtigt. Den reelle tidsplan afhænger af tilladelse, bil og finansiering, det lægger vi fast i afklaringen, så du ikke leaser en bil, der står stille." },
    ],
    cta: { title: "Skal vi starte din vognmandsforretning op?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ REGNSKAB */
  regnskab: {
    slug: "regnskab",
    eyebrow: "Økonomi",
    h1: "Bogføring, moms og regnskab",
    lead:
      "Vi fører bogen selv, ikke via en partner. Løbende bogføring, afstemning, moms og et grundlag til årsrapporten, der er til at arbejde videre med.",
    meta: {
      title: "Bogføring, moms og regnskab for vognmænd | Votra Business",
      description:
        "Løbende bogføring, afstemning, momsopgørelse og grundlag til årsrapport. Udført in-house af Votra Business, med transport som speciale.",
    },
    service: {
      name: "Bogføring, moms og regnskabsassistance",
      description: "Løbende bogføring, afstemning, momsopgørelse og udarbejdelse af grundlag til årsrapport.",
    },
    blocks: [
      {
        type: "split",
        heading: "Hvad der ligger i det",
        columns: [
          { title: "Løbende", items: ["Bogføring og kontering af alle bilag", "Afstemning af bank, kort og kasse", "Debitor- og kreditorbogholderi", "Momsopgørelse og indberetning", "Oprydning i åbne poster"] },
          { title: "Periodisk", items: ["Periodebalance med forklaring", "Kvartalsgennemgang", "Budgetopfølgning", "Årsrapporten udarbejdet og indberettet", "Samarbejde med revisor, hvis der kræves en erklæring"] },
        ],
      },
      {
        type: "callout",
        title: "Hvorfor transport kræver en særlig kontoplan",
        text: "En standardkontoplan samler alt i «driftsomkostninger». Det gør tallene ubrugelige for en vognmand. Vi sætter kontoplanen op, så brændstof, leasing, forsikring, dæk, service, vejafgifter og chaufførløn kan følges hver for sig, og så omkostningerne kan henføres til den enkelte bil.",
      },
      {
        type: "callout",
        tone: "warn",
        title: "Hvad vi ikke er",
        text: "Votra Business er ikke revisionsvirksomhed og udfører ikke revision. Vi laver bogføring, momsopgørelse, løn, controlling og årsrapporten selv. Skal regnskabet revideres eller forsynes med en revisorerklæring, fordi banken, et leasingselskab eller et udbud kræver det, løses den del af en revisor. Du kan beholde den, du har, eller vi peger på en i vores netværk.",
      },
      {
        type: "media",
        image: BILLEDER.papirbunke,
        alt: "Høje stakke af papirer og mapper på et kontor",
        caption:
          "Det er sådan et år ser ud, når bilagene venter på vinteren. Jo længere bunken ligger, jo dyrere bliver oprydningen, og jo mindre ved du om, hvordan det faktisk går.",
      },
      { type: "packages", intro: "Bogføring og moms er med fra grundpakken." },
      rel(["drift", "loen", "financial-controlling", "andre-virksomheder"]),
    ],
    faq: [
      { q: "Laver I årsregnskabet?", a: "Ja. Vi laver årsrapporten selv, når året er bogført og afstemt. Skal regnskabet revideres eller forsynes med en revisorerklæring, løses den del af en revisor, vi leverer et færdigt, afstemt grundlag." },
      { q: "Hvilket system bruger I?", a: "Vi arbejder i dit nuværende system, hvis du har et, ellers opretter vi et. Vi arbejder bl.a. i e-conomic." },
      { q: "Kan I overtage et rodet bogholderi?", a: "Ja. Vi starter med at opgøre, hvor meget der mangler, og hvad oprydningen koster, og siger det, før vi begynder." },
      { q: "Bogfører I kun for vognmænd?", a: "Nej. Transport er vores speciale, men vi laver også bogføring, moms og løn for andre små og mellemstore virksomheder." },
    ],
    cta: { title: "Skal vi overtage bogholderiet?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ LØN */
  loen: {
    slug: "loen",
    eyebrow: "Økonomi",
    h1: "Løn og chaufførafregning",
    lead:
      "Chaufførløn er ikke en standardlønseddel. Tillæg, ventetid, diæter, overenskomstvilkår og lokalaftaler skal med, hver gang, til tiden.",
    meta: {
      title: "Lønadministration og chaufførafregning | Votra Business",
      description:
        "Vi kører lønnen for transportvirksomheder: tillæg, ventetid, overenskomstvilkår, pension, feriepenge og indberetninger. Ansættelseskontrakter samlet i portalen.",
    },
    service: {
      name: "Lønadministration for transportvirksomheder",
      description: "Lønkørsel, chaufførafregning, tillæg, pension, feriepenge og indberetninger for vognmænd og SMV.",
    },
    blocks: [
      {
        type: "checklist",
        heading: "Det vi håndterer",
        items: [
          "Lønkørsel til aftalt tid, også 14-dages løn",
          "Tillæg, ventetid, diæter og kørselsafhængige poster",
          "Vilkår efter overenskomst eller lokalaftale",
          "Pension, feriepenge og fritvalg",
          "Indberetning til myndigheder",
          "Ansættelseskontrakter med chaufførspecifikke felter",
          "Sygdom, fravær og refusioner",
          "Lønomkostning pr. bil og pr. chauffør til controlling",
        ],
      },
      {
        type: "callout",
        title: "Kontrakten og lønnen hænger sammen",
        text: "Når ansættelseskontrakten ligger i portalen med overenskomst, tillæg, pension, arbejdstøj, brændstofkort og fast bil eller rute, er lønnen ikke et fortolkningsspørgsmål hver måned. Det er samme sted, vi holder øje med kørekort, EU-bevis, førerkort og ADR.",
        link: { label: "Se dokument- og fristovervågning", to: "/business/compliance" },
      },
      { type: "packages", intro: "Løn er med fra Business+ og op." },
      rel(["compliance", "rekruttering", "regnskab",
        art("hvad-koster-en-chauffoer", "Hvad koster en chauffør", "Lønnen er kun en del af den samlede omkostning.")]),
    ],
    faq: [
      { q: "Kan I køre løn efter overenskomst?", a: "Ja. Vi lægger overenskomst- eller lokalaftalevilkår ind på den enkelte medarbejder, så lønnen kører efter det, der faktisk er aftalt." },
      { q: "Hvad skal jeg selv indberette?", a: "Du melder ændringer, nye medarbejdere, fravær, ekstra tillæg. Resten kører hos os efter en fast kadence." },
      { q: "Laver I ansættelseskontrakter?", a: "Ja, med de felter transport kræver: kørekort, EU-bevis, førerkort, ADR, overenskomst, løn- og pensionsvilkår, arbejdstøj, brændstofkort og fast bil eller rute. De underskrives digitalt og ligger i portalen." },
    ],
    cta: { title: "Skal vi køre lønnen?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ ANDRE VIRKSOMHEDER */
  "andre-virksomheder": {
    slug: "andre-virksomheder",
    eyebrow: "Uden flåde",
    h1: "Regnskab og administration for andre virksomheder",
    lead:
      "Vores dybeste specialisering er transport. Men driftsmodellen er den samme for enhver lille virksomhed, hvor ejeren laver arbejdet om dagen og administrationen om aftenen: vi overtager kontoret.",
    meta: {
      title: "Bogføring og løn for små virksomheder | Votra Business",
      description:
        "Votra Business laver bogføring, moms, løn, fakturering og økonomistyring for små og mellemstore virksomheder, samme driftsmodel, uden fleet-delen.",
    },
    service: {
      name: "Bogføring, løn og administration for SMV",
      description: "Outsourcet bogføring, moms, løn, fakturering og økonomistyring for små og mellemstore virksomheder.",
    },
    blocks: [
      {
        type: "split",
        heading: "Hvad du får",
        columns: [
          { title: "Det løbende", items: ["Bogføring og afstemning", "Moms og indberetning", "Fakturering og rykkere", "Løn og indberetninger", "Leverandørfakturaer og betalinger"] },
          { title: "Det styrende", items: ["Periodebalance du kan forstå", "Kvartalsgennemgang", "Budget og likviditet", "Årsrapporten udarbejdet", "Fast rådgiver og egen portal"] },
        ],
      },
      {
        type: "callout",
        title: "Vi skriver ikke, at vi er specialister i alle brancher",
        text: "Det er de færreste. Vores dybeste specialisering er transport, og det er der, vi har de skarpeste nøgletal. Driver du håndværk, service, butik eller klinik, får du den samme driftsmodel og den samme faste rådgiver, bare uden fleet- og compliance-delen.",
      },
      { type: "packages", intro: "Uden flåde er Business og Business+ typisk det rigtige niveau." },
      rel(["regnskab", "loen", "portal", "kontakt"]),
    ],
    faq: [
      { q: "Er I dyrere, fordi I er specialiseret i transport?", a: "Nej. Prisen følger arbejdsmængden: bilagsmængde, antal lønsedler og hvor meget du afleverer. Fleet- og compliance-delen betaler du kun for, hvis du har biler." },
      { q: "Kan jeg starte med bogføring og tilføje løn senere?", a: "Ja. De fleste begynder med bogføring og moms og lægger løn og controlling over, når det fungerer." },
      { q: "Får jeg også adgang til portalen?", a: "Ja. Kontrakter, bogføringsstatus, moms, bank og dokumenter ligger samme sted, uanset om du har biler eller ikke." },
    ],
    cta: { title: "Skal vi tage administrationen i din virksomhed?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ PORTAL */
  portal: {
    slug: "portal",
    eyebrow: "Produkt",
    h1: "Votra Business Portal",
    lead:
      "Et softwarefirma giver dig et system. En bogholder giver dig et regnskab. Du får begge dele, og et menneske, der kender din forretning. Portalen er ikke en ekstra ting at vedligeholde; det er stedet, hvor du kan se, at arbejdet bliver gjort.",
    meta: {
      title: "Votra Business Portal: kontrakter og økonomi",
      description:
        "Se kontrakter med digital underskrift, chaufførdokumenter med udløbsdatoer, transport-aftaler med beløb, bogføringsstatus, moms og likviditet i din egen portal.",
    },
    service: {
      name: "Votra Business Portal",
      description: "Kundeportal med kontrakter, medarbejderdokumenter, transport-aftaler, bogføringsstatus, moms, bank og kvartalskontrol.",
    },
    blocks: [
      { type: "portal", heading: "Hvad portalen indeholder", full: true },
      {
        type: "callout",
        title: "Vi viser ikke funktioner, der ikke findes",
        text: "Listen ovenfor er delt i to med vilje. Det øverste kører i dag. Det nederste er under udvikling, og du ser det ikke som en faneblad i portalen, før det gør mere end at se godt ud. Hvis du har brug for noget af det nu, leverer vi det manuelt som del af controlling.",
      },
      {
        type: "cards",
        heading: "Hvorfor det er mere end et login",
        items: [
          { title: "Dokumenter med datoer", desc: "Kørekort, EU-bevis, førerkort og ADR ligger med udløbsdato pr. medarbejder, ikke i en mappe i en mail." },
          { title: "Aftaler med beløb", desc: "Forsikring, leasing og brændstof med leverandør, beløb, periode og det underskrevne dokument." },
          { title: "Underskrift i to led", desc: "Kontrakter underskrives digitalt af både dig og Votra Business, og status er synlig hele vejen." },
          { title: "Fast rådgiver", desc: "Du har en navngiven kontaktperson i portalen, ikke en supportkø." },
        ],
      },
      {
        type: "steps",
        heading: "Sådan får du adgang",
        items: [
          { n: "01", title: "Driftsgennemgang", desc: "Vi aftaler hvad vi overtager, og hvad du har brug for at kunne se." },
          { n: "02", title: "Oprettelse", desc: "Du får et login, og vi lægger biler, medarbejdere, aftaler og dokumenter ind." },
          { n: "03", title: "Drift", desc: "Herefter opdateres portalen som en del af den løbende drift, du skal ikke vedligeholde den selv." },
        ],
      },
      rel(["drift", "compliance", "fleet-management", "financial-controlling"]),
    ],
    faq: [
      { q: "Koster portalen ekstra?", a: "Nej. Adgang til portalen er en del af samarbejdet fra grundpakken og op." },
      { q: "Er mine data mine?", a: "Ja. Dine bilag, kontrakter og dokumenter er din virksomheds. Du kan trække dem ud, og du beholder dem, hvis samarbejdet stopper." },
      { q: "Kan mine chauffører få adgang?", a: "Portalen er bygget til virksomheden og dens administration. Medarbejderdokumenter håndteres af dig og os, kontakt os, hvis du har brug for en særlig adgang." },
      { q: "Kan jeg se resultat pr. bil i portalen?", a: "Opstillingen leverer vi i dag som del af controlling. Den automatiske visning pr. bil i portalen er under udvikling." },
    ],
    cta: { title: "Vil du se portalen med dine egne tal?", button: "Få en driftsgennemgang" },
    portalLogin: true,
  },

  /* ============================================================ REKRUTTERING */
  rekruttering: {
    slug: "rekruttering",
    eyebrow: "Medarbejdere",
    h1: "Chauffører og medarbejdere",
    lead:
      "En bil uden chauffør er en omkostning. Vi hjælper med at få folk ind ad døren og få papirerne på plads, så den første arbejdsdag ikke bliver en administrativ opgave for dig.",
    meta: {
      title: "Rekruttering af chauffører og medarbejdere | Votra Business",
      description:
        "Hjælp til at finde, ansætte og onboarde chauffører: annoncering, screening, ansættelseskontrakt med chaufførspecifikke felter og dokumenter i portalen.",
    },
    service: {
      name: "Rekruttering og onboarding af chauffører",
      description: "Annoncering, screening, ansættelseskontrakter og onboarding af chauffører og administrative medarbejdere.",
    },
    blocks: [
      {
        type: "steps",
        heading: "Fra behov til første arbejdsdag",
        items: [
          { n: "01", title: "Behov", desc: "Hvilken kørsel, hvilke beviser, hvilke vilkår, og hvad må medarbejderen koste for at bilen løber rundt." },
          { n: "02", title: "Opslag", desc: "Vi formulerer og slår stillingen op med de krav, der faktisk skal opfyldes." },
          { n: "03", title: "Screening", desc: "Vi gennemgår ansøgere og kontrollerer, at kørekort, EU-bevis, førerkort og ADR er gyldige." },
          { n: "04", title: "Ansættelse", desc: "Kontrakt med overenskomst- og lønvilkår, digital underskrift og dokumenter lagt i portalen." },
          { n: "05", title: "Onboarding", desc: "Løn oprettet, brændstofkort, arbejdstøj, fast bil eller rute og frister sat op fra dag ét." },
        ],
      },
      {
        type: "callout",
        title: "Ærligt om hvad vi er",
        text: "Vi er ikke et vikarbureau, og vi har ikke en pulje af chauffører på hylden. Vi hjælper med at finde, vurdere og ansætte, og vi tager hele den administrative del af en ansættelse. Har du brug for akut vikardækning, siger vi det ærligt og peger videre.",
      },
      {
        type: "callout",
        title: "Uddannelse i koncernen",
        text: "Mangler en kandidat et bevis, kan uddannelsen tages hos Votra Danmark ApS, der har uddannet vognmænd og chauffører siden 2015. Det gør det muligt at ansætte en, der næsten er klar, og få resten på plads.",
        link: { label: "Se uddannelserne", to: "/kurser" },
      },
      rel(["compliance", "loen", "vaekst", "kurser"]),
    ],
    faq: [
      { q: "Garanterer I, at I finder en chauffør?", a: "Nej. Vi laver arbejdet, opslag, screening, kontrol og ansættelse, men vi lover ikke et resultat i et marked, hvor chauffører er svære at finde." },
      { q: "Kontrollerer I beviser og certifikater?", a: "Ja. Kørekort, EU-bevis, førerkort og ADR kontrolleres ved ansættelsen og lægges derefter ind med udløbsdato, så de også bliver fornyet til tiden." },
      { q: "Laver I ansættelseskontrakterne?", a: "Ja, med de felter transport kræver, og med digital underskrift. De ligger samlet i portalen." },
    ],
    cta: { title: "Mangler du folk, eller styr på papirerne?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ PARTNERE */
  partnere: {
    slug: "partnere",
    eyebrow: "Netværk",
    h1: "Partnernetværk med roller",
    lead:
      "Logoer uden forklaring er ikke et bevis på noget. Her står hvad hver relation faktisk dækker, og hvor grænsen går mellem det vi gør, og det en partner gør.",
    meta: {
      title: "Partnere og samarbejdspartnere | Votra Business",
      description:
        "Votra Business’ partnernetværk med beskrevne roller: indkøbsfællesskab, forsikring, brændstof, regnskabssystem, bank og revision. Vi skriver hvem der gør hvad.",
    },
    blocks: [
      { type: "partners", heading: "Vores netværk", intro: "Aftaler med leverandører indgås mellem dig og leverandøren. Vi laver arbejdet omkring dem: papirer, kontrol, frister og administration." },
      {
        type: "callout",
        title: "Sådan skriver vi om partnere",
        text: "Vi skriver ikke «vi forsikrer din flåde» eller «vores revisor». Vi skriver hvem der gør hvad. Hvis du er i tvivl om en konkret relation, hvem der rådgiver, hvem der formidler, og hvem der har ansvaret, så spørg os, og du får et konkret svar.",
      },
      { type: "boundaries", heading: "Det gør vi ikke selv" },
      {
        type: "callout",
        title: "Koncernen",
        text: "Votra Business ApS er en del af Votra-koncernen sammen med Votra Danmark ApS, der udbyder vognmands- og chaufføruddannelser og har gjort det siden 2015. Det er grunden til, at vi kan følge en vognmand fra uddannelse til drift, uddannelsen ligger hos Votra Danmark, driften hos Votra Business.",
        link: { label: "Se uddannelserne", to: "/kurser" },
      },
      rel(["rammeaftaler", "fleet-management", "om-os", "vilkaar"]),
    ],
    faq: [
      { q: "Ejer I nogen af partnerne?", a: "Nej. Partnerne er selvstændige virksomheder. Votra Business ApS er en del af Votra-koncernen sammen med Votra Danmark ApS." },
      { q: "Kan jeg bruge mine egne leverandører?", a: "Ja. Vi administrerer de aftaler, du har, vi kræver ikke, at du skifter til nogen i vores netværk." },
    ],
    cta: { title: "Spørgsmål til en konkret relation?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ CASES */
  cases: {
    slug: "cases",
    eyebrow: "Dokumentation",
    h1: "Cases",
    // Siden er bevidst tom: vi offentliggør ikke cases vi ikke kan dokumentere.
    // Indtil den første rigtige case ligger her, skal siden ikke indekseres, men
    // den skal stadig kunne åbnes fra navigationen. Fjern `noindex` og læg URL'en
    // tilbage i sitemap.xml, når der er en substantiel case at vise.
    noindex: true,
    lead:
      "Vi offentliggør ikke cases, vi ikke kan dokumentere, og vi lægger ikke kundenavne ud uden tilladelse. Derfor er der ikke noget her endnu, og det er et bevidst valg.",
    meta: {
      title: "Cases | Votra Business",
      description:
        "Votra Business offentliggør kun dokumenterede, anonymiserede cases med kundens tilladelse. Her står hvad en case kommer til at indeholde.",
    },
    blocks: [
      {
        type: "empty",
        heading: "Ingen cases offentliggjort endnu",
        text: "Votra Business ApS er et nyt selskab i Votra-koncernen. Når de første forløb har kørt længe nok til at der er reelle tal at vise, offentliggør vi dem her, anonymiseret og med kundens tilladelse.",
      },
      {
        type: "checklist",
        heading: "Sådan kommer en case til at se ud",
        intro: "Formatet ligger fast, så du kan gennemskue, hvad du får fortalt, og hvad vi ikke fortæller.",
        items: [
          "Virksomhedstype og størrelse, fx «transportvirksomhed med 3 lastbiler»",
          "Udgangspunktet: hvad lå hos ejeren, og hvad var problemet",
          "Hvad vi overtog, og hvornår",
          "Hvad der konkret ændrede sig, i kroner eller i dage",
          "Hvad vi ikke løste",
          "Ingen navne uden skriftlig tilladelse",
        ],
      },
      {
        type: "callout",
        title: "Er du kunde?",
        text: "Vil du gerne stå frem, hører vi meget gerne fra dig. Vi skriver intet uden din godkendelse, og du ser teksten, før den bliver offentliggjort.",
        link: { label: "Få en driftsgennemgang", to: "/business/kontakt" },
      },
      rel(["om-os", "viden", "vognmaend", "kontakt"]),
    ],
    faq: [],
    cta: { title: "Vil du høre, hvad vi konkret kan gøre i din forretning?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ OM OS */
  "om-os": {
    slug: "om-os",
    eyebrow: "Om os",
    h1: "Hvem vi er",
    lead:
      "Votra Business ApS er en ekstern drifts- og økonomiafdeling for vognmænd. Vi er et nyt selskab i en koncern, der har arbejdet med transportbranchen siden 2015, og vi siger det, i stedet for at skrive at vi har ti års erfaring.",
    meta: {
      title: "Om Votra Business ApS, CVR 46818296",
      description:
        "Votra Business ApS, CVR 46818296, er en ekstern drifts- og økonomiafdeling for vognmænd. Kontor i Søborg, registreret adresse i Ringsted. Del af Votra.",
    },
    blocks: [
      {
        type: "facts",
        heading: "Selskabsoplysninger",
      },
      {
        type: "prose",
        heading: "Hvorfor vi findes",
        paragraphs: [
          "En vognmand skal i dag bruge fem leverandører for at drive sin forretning: en bogholder til bilagene, et softwarefirma til bilerne, en rådgiver til aftalerne, et kursussted til beviserne og en revisor til årsregnskabet. Ingen af dem har det fulde billede, og ejeren ender med at være den, der binder det sammen, om aftenen.",
          "Votra Business er bygget til at tage den rolle. Vi udfører arbejdet i stedet for at rådgive om det, og vi holder bilernes økonomi og chaufførernes papirer på samme bord som regnskabet. Det er hele forskellen: en bogholder ved ikke, hvornår en leasingaftale udløber, og et flådesystem ved ikke, hvad bilen tjente.",
          "Vi er ikke en brancheorganisation, og vi er ikke revisorer. Vi er driftskontoret.",
        ],
      },
      {
        type: "prose",
        heading: "Koncernen",
        paragraphs: [
          "Votra Danmark ApS (CVR 36486899) har siden 2015 uddannet vognmænd og chauffører og er godkendt prøveudbyder hos Færdselsstyrelsen. Det er her, vognmandsuddannelsen, chaufføruddannelserne og prøverne ligger.",
          "Votra Business ApS (CVR 46818296) er drifts- og økonomidelen. Sammen dækker de to selskaber vejen fra bevis til virksomhed til drift, men det er to selskaber, og vi skriver ikke det enes historie på det andets side.",
        ],
      },
      {
        type: "advisors",
        heading: "Dem du kommer til at tale med",
        intro: "Du får en fast rådgiver, ikke en supportkø. Her er de rådgivere, du møder hos Votra Business.",
        fallback: {
          heading: "Rådgiverprofiler er på vej",
          text: "Vi lægger navne, titler, ansvarsområder og faglig baggrund op, når hver profil er verificeret. Indtil da får du navnet på din faste rådgiver ved den første driftsgennemgang, og i portalen, når samarbejdet starter.",
        },
      },
      { type: "boundaries", heading: "Det gør vi ikke" },
      rel(["vognmaend", "partnere", "portal", "kontakt"]),
    ],
    faq: [
      { q: "Hvor gammelt er Votra Business?", a: "Votra Business ApS er et nyt selskab. Koncernen har arbejdet med transportbranchen siden 2015 gennem Votra Danmark ApS. Vi skriver ikke koncernens år på Business-selskabets regning." },
      { q: "Hvor ligger I?", a: "Vi har registreret adresse på Sct. Hansgade 9, 4100 Ringsted og arbejder fra Votra-koncernens kontor på Transformervej 14, 2860 Søborg. Vi arbejder for kunder i hele Danmark." },
      { q: "Hvem ejer selskabet?", a: "Votra Business ApS er en del af Votra-koncernen. Ejer- og ledelsesforhold kan slås op i Det Offentlige Ejerregister på virk.dk, vi skriver ikke mere her, end der står registreret." },
    ],
    cta: { title: "Lad os tage en snak om din drift", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ VIDEN */
  viden: {
    slug: "viden",
    eyebrow: "Viden",
    h1: "Økonomi og drift for vognmænd",
    lead:
      "Konkret viden om det, der afgør om en vognmandsforretning tjener penge: omkostninger pr. bil, likviditet, aftaler og administration. Skrevet af dem, der laver arbejdet.",
    meta: {
      title: "Viden om økonomi og drift for vognmænd | Votra Business",
      description:
        "Artikler om økonomi, drift og administration for vognmænd: omkostninger pr. bil, likviditet, kontrakter, dokumenter og opstart.",
    },
    blocks: [
      { type: "articles", heading: "Alle artikler", all: true },
      {
        type: "callout",
        title: "Vil du regne på det i stedet for at læse om det?",
        text: "Vi har tre beregnere til de spørgsmål, artiklerne handler om: hvad koster en kilometer, hvor meget skal bilen køre for at løbe rundt, og kan den næste bil betale sig.",
        link: { label: "Åbn beregnerne", to: "/business/beregnere" },
      },
      {
        type: "cards",
        heading: "Hvad vi skriver om",
        intro: "Fire spor. Vi udvider dem løbende.",
        items: [
          { title: "Økonomi for vognmænd", desc: "Omkostninger pr. bil, dækningsbidrag, break-even, likviditet og debitordage." },
          { title: "Fleet", desc: "Aftaler, leasing, forsikring, service, aflevering og hvad en bil koster om måneden." },
          { title: "Drift", desc: "Fakturering, løn, dokumenter, frister og de rutiner der holder forretningen kørende." },
          { title: "Opstart", desc: "Tilladelse, selskabsform, åbningsbudget og den første bil." },
        ],
      },
      rel(["vognmaend", "financial-controlling", "fleet-management", "beregnere"], "Siderne bag artiklerne"),
    ],
    faq: [],
    cta: { title: "Vil du have tallene regnet igennem på din egen forretning?", button: "Få en driftsgennemgang" },
  },

  /* ============================================================ KONTAKT */
  kontakt: {
    slug: "kontakt",
    eyebrow: "Kontakt",
    h1: "Få en driftsgennemgang",
    lead:
      "En driftsgennemgang er en samtale om, hvad du sidder med i dag, og hvad der kan flyttes. Du får at vide, hvad vi vil overtage, hvad det kræver af dig, og hvad det koster, før du beslutter noget.",
    meta: {
      title: "Kontakt Votra Business, få en driftsgennemgang",
      description:
        "Kontakt Votra Business ApS. Ring, skriv eller book en driftsgennemgang af din vognmandsforretning. Kontor i Søborg, registreret adresse i Ringsted.",
    },
    blocks: [
      {
        type: "checklist",
        heading: "Det kigger vi på i gennemgangen",
        items: [
          "Hvor mange biler og chauffører, og hvilken kørsel",
          "Hvad der ligger hos dig, en bogholder, en revisor eller ingen",
          "Hvilke systemer du bruger i dag",
          "Hvordan faktureringen og debitoropfølgningen kører",
          "Hvad dine faste omkostninger er pr. bil",
          "Hvilke dokumenter og frister der mangler styring",
          "Hvad der kan flyttes først, og hvad der kan vente",
        ],
      },
      { type: "contact" },
      { type: "advisors", heading: "Rådgivere du kan ringe direkte til", intro: "Du behøver ikke gå gennem en hovedomstilling." },
      { type: "facts", heading: "Selskabsoplysninger" },
      rel(["vognmaend", "beregnere", "portal", "om-os"]),
    ],
    faq: [
      { q: "Koster en driftsgennemgang noget?", a: "Nej. Du får et konkret oplæg på, hvad vi vil overtage, og hvad det koster, uden forpligtelse." },
      { q: "Hvad skal jeg have klar?", a: "Ingenting for at tage snakken. Vil du have et præcist tilbud, hjælper det med adgang til regnskabet, antal biler og medarbejdere samt dine faste aftaler." },
      { q: "Hvor hurtigt svarer I?", a: "Vi vender tilbage inden for en hverdag." },
    ],
    cta: null,
  },

  /* ============================================================ VILKÅR */
  vilkaar: {
    slug: "vilkaar",
    eyebrow: "Juridisk",
    h1: "Samarbejds- og handelsvilkår",
    lead:
      "Vilkårene nedenfor gælder for ydelser leveret af Votra Business ApS, CVR 46818296, medmindre andet er skriftligt aftalt i den enkelte samarbejdsaftale.",
    meta: {
      title: "Samarbejds- og handelsvilkår | Votra Business ApS",
      description: "Samarbejds- og handelsvilkår for ydelser leveret af Votra Business ApS, CVR 46818296.",
    },
    noindex: false,
    blocks: [
      { type: "facts", heading: "Aftalepart" },
      {
        type: "prose",
        heading: "1. Ydelsens omfang",
        paragraphs: [
          "Votra Business ApS leverer administrative ydelser, herunder bogføring, momsopgørelse, lønadministration, fakturering, debitor- og kreditorstyring, udarbejdelse af årsrapport, financial controlling, administrativ flådestyring samt administrativ dokument- og fristovervågning.",
          "Omfanget af den konkrete opgave fremgår af samarbejdsaftalen. Ydelser, der ikke er nævnt i aftalen, leveres kun efter særskilt skriftlig aftale.",
        ],
      },
      {
        type: "prose",
        heading: "2. Hvad vi ikke leverer",
        paragraphs: [
          "Votra Business ApS er ikke godkendt revisionsvirksomhed og udfører ikke revision, review eller afgiver erklæringer med sikkerhed. Kræves der en revisorerklæring på regnskabet, henvises opgaven til en revisor.",
          "Votra Business ApS yder ikke juridisk rådgivning, forsikringsrådgivning eller investeringsrådgivning. Forsikringsaftaler indgås mellem kunden og forsikringsselskabet eller dennes formidler. Leasing- og finansieringsaftaler indgås mellem kunden og leverandøren.",
          "Votra Business ApS formidler ikke kørselsopgaver og garanterer ikke omsætning, kontrakter eller besparelser.",
          "Beregnere og regneeksempler på votra.dk er vejledende og baseret udelukkende på de oplysninger, brugeren selv indtaster. De udgør ikke rådgivning, og Votra Business ApS er ikke ansvarlig for beslutninger truffet alene på grundlag af dem.",
        ],
      },
      {
        type: "prose",
        heading: "3. Kundens medvirken",
        paragraphs: [
          "Kunden er ansvarlig for rettidigt at levere fuldstændige og korrekte oplysninger, bilag og dokumenter samt for at oplyse om ændringer i virksomheden, medarbejderforhold og aftaler.",
          "Ansvaret for, at virksomheden overholder gældende lovgivning, tilladelser og indberetningsfrister, påhviler kunden. Votra Business ApS' overvågning af frister er en administrativ hjælpefunktion og fritager ikke kunden for dette ansvar.",
        ],
      },
      {
        type: "prose",
        heading: "4. Priser og betaling",
        paragraphs: [
          "Priser fastsættes i samarbejdsaftalen og kan bestå af en grundpris samt variable elementer pr. køretøj og pr. medarbejder. Alle priser er ekskl. moms, medmindre andet er angivet.",
          "Betalingsbetingelser fremgår af fakturaen. Ved manglende betaling kan arbejdet suspenderes efter skriftligt varsel.",
        ],
      },
      {
        type: "prose",
        heading: "5. Fortrolighed og data",
        paragraphs: [
          "Votra Business ApS behandler kundens oplysninger fortroligt og anvender dem alene til at levere de aftalte ydelser. Behandling af personoplysninger sker efter en særskilt databehandleraftale, når Votra Business ApS behandler personoplysninger på kundens vegne.",
          "Kundens bilag, kontrakter og dokumenter tilhører kunden og kan udleveres ved ophør.",
        ],
      },
      {
        type: "prose",
        heading: "6. Ansvar",
        paragraphs: [
          "Votra Business ApS er ansvarlig efter dansk rets almindelige regler med de begrænsninger, der fremgår af samarbejdsaftalen. Votra Business ApS er ikke ansvarlig for indirekte tab, driftstab eller tab som følge af mangelfulde eller forsinkede oplysninger fra kunden.",
        ],
      },
      {
        type: "prose",
        heading: "7. Varighed og opsigelse",
        paragraphs: [
          "Samarbejdet løber, indtil det opsiges efter de vilkår, der fremgår af samarbejdsaftalen. Ved ophør afleveres bogføringsmateriale og dokumenter til kunden eller til den, kunden udpeger.",
        ],
      },
      {
        type: "prose",
        heading: "8. Lovvalg",
        paragraphs: [
          "Aftalen er underlagt dansk ret. Uenigheder søges løst i dialog og afgøres i øvrigt ved de danske domstole.",
        ],
      },
      {
        type: "callout",
        title: "Spørgsmål til vilkårene",
        text: "Skriv til kundeservice@votra.dk, så gennemgår vi dem med dig, før du skriver under. Den konkrete samarbejdsaftale går altid forud for disse generelle vilkår.",
      },
      rel(["privatliv", "om-os", "kontakt"]),
    ],
    faq: [],
    cta: null,
  },

  /* ============================================================ PRIVATLIV */
  privatliv: {
    slug: "privatliv",
    eyebrow: "Juridisk",
    h1: "Privatlivspolitik",
    lead:
      "Her står, hvilke oplysninger Votra Business ApS behandler, hvorfor vi gør det, hvor længe vi opbevarer dem, og hvilke rettigheder du har.",
    meta: {
      title: "Privatlivspolitik | Votra Business ApS",
      description: "Sådan behandler Votra Business ApS (CVR 46818296) personoplysninger, formål, grundlag, opbevaring og dine rettigheder.",
    },
    blocks: [
      { type: "facts", heading: "Dataansvarlig" },
      {
        type: "prose",
        heading: "1. Hvilke oplysninger vi behandler",
        paragraphs: [
          "Ved henvendelser gennem vores formularer behandler vi navn, telefonnummer, e-mailadresse og indholdet af din besked.",
          "Bruger du en af beregnerne på votra.dk, behandler vi desuden de tal, du selv indtaster om din virksomhed og dine køretøjer, sammen med dit navn, din e-mailadresse og eventuelt telefonnummer og virksomhedsnavn, så vi kan sende beregningen til dig og følge op på den.",
          "I et kundeforhold behandler vi desuden virksomhedsoplysninger, regnskabs- og bilagsdata, aftaler og, hvor det er nødvendigt for at levere ydelsen, oplysninger om medarbejdere, herunder løn- og ansættelsesvilkår samt kørekort, EU-bevis, førerkort og ADR med tilhørende udløbsdatoer.",
        ],
      },
      {
        type: "prose",
        heading: "2. Formål og grundlag",
        paragraphs: [
          "Vi behandler oplysningerne for at besvare henvendelser, indgå og opfylde aftaler, levere bogføring, løn og administration samt overholde vores egne retlige forpligtelser, herunder bogføringsloven.",
          "Grundlaget er typisk opfyldelse af en aftale, vores legitime interesse i at besvare din henvendelse eller en retlig forpligtelse. Behandler vi personoplysninger på en kundes vegne, sker det som databehandler efter en databehandleraftale.",
        ],
      },
      {
        type: "prose",
        heading: "3. Deling",
        paragraphs: [
          "Oplysninger deles kun, når det er nødvendigt: med it-leverandører og regnskabssystemer, der behandler data på vores vegne, med myndigheder, hvor vi er forpligtet til at indberette, og med rådgivere som fx revisor, når kunden har bedt om det.",
          "Vi sælger ikke personoplysninger og bruger dem ikke til profilering eller automatiske afgørelser.",
        ],
      },
      {
        type: "prose",
        heading: "4. Opbevaring",
        paragraphs: [
          "Henvendelser, der ikke bliver til et kundeforhold, slettes, når de ikke længere har et formål. Regnskabsmateriale opbevares i den periode, bogføringsloven kræver. Personoplysninger om medarbejdere opbevares, så længe det er nødvendigt for at levere ydelsen og opfylde lovkrav.",
        ],
      },
      {
        type: "prose",
        heading: "5. Dine rettigheder",
        paragraphs: [
          "Du har ret til indsigt i de oplysninger, vi behandler om dig, til at få urigtige oplysninger rettet, til i visse tilfælde at få oplysninger slettet eller behandlingen begrænset, og til at gøre indsigelse mod behandlingen.",
          "Vil du bruge dine rettigheder, skriv til kundeservice@votra.dk. Du kan klage til Datatilsynet, hvis du er utilfreds med vores behandling.",
        ],
      },
      {
        type: "prose",
        heading: "6. Cookies",
        paragraphs: [
          "På votra.dk anvendes cookies til at få siden til at fungere og til statistik. Du kan til enhver tid ændre eller tilbagekalde dit samtykke via cookiebanneret på siden.",
        ],
      },
      rel(["vilkaar", "om-os", "kontakt"]),
    ],
    faq: [],
    cta: null,
  },
};

export const BUSINESS_PAGE_SLUGS = Object.keys(BUSINESS_PAGES);
